/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useRequest } from 'ahooks'
import { ChannelConfigWithStandardChannelsInfo, StandardChannelDef, GridChartConfig } from './api'

export function useStandardChannels() {
    return useRequest<Record<string, StandardChannelDef>, null>(
        () =>
            fetch(`/services/plugin-grid-widget/standard-channels/`).then(
                r => r.json(),
                () => ({})
            ),
        {
            cacheKey: 'standard-channels',
            cacheTime: 1000 * 60 * 5 // 5 minutes
        }
    )
}

export const useChannelsConfigWithStandardChannelsInfo = function useChannelsConfigWithStandardChannelsInfo(
    channelsConfig: GridChartConfig['channels']
): ChannelConfigWithStandardChannelsInfo[] {
    const { data: standardChannels = {} } = useStandardChannels()
    return (
        channelsConfig?.map(channelCfg => {
            return {
                ...channelCfg,
                name: channelCfg.name,
                color: channelCfg.color ?? standardChannels[channelCfg.mnemonic]?.color
            }
        }) || []
    )
}
